// extracted by mini-css-extract-plugin
export default {"energy-container":"energy-label-product-info-component_energy-container__gGI5X","energy-link":"energy-label-product-info-component_energy-link__NvPSp"};